import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgForm, FormsModule } from '@angular/forms';
import {FormBuilder, FormGroup, Validators, FormArray, FormControl} from '@angular/forms';
import {EndpointService} from "../../../services/endpoint/endpoint.service";


export interface DialogDeleteUserData {
  user_name: string;
  user_id: any;
  user_email: string;
}

@Component({
  selector: 'app-dialog-delete-user',
  templateUrl: './dialog-delete-user.component.html',
  styleUrls: ['./dialog-delete-user.component.scss']
})
export class DialogDeleteUserComponent implements OnInit {
    deleteFormGroup: FormGroup;

    constructor(
        public dialogRef: MatDialogRef<DialogDeleteUserComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogDeleteUserData,
        private _formBuilder: FormBuilder,
        private endpointSrv: EndpointService,

    ) { }

    ngOnInit(): void {
        this.deleteFormGroup = this._formBuilder.group(
        {
            delete: ['', Validators.required],
        });
    }
    onNoClick(): void {
      this.dialogRef.close();
    }
    deleteUser(user_id, user_email, user_name){
        if(this.deleteFormGroup.value.delete == 'DELETE'){
            this.endpointSrv.sendContactMessageToWhooosh(user_id, user_email, user_name, 'Delete my account', "delete user").subscribe(data=>{
                 this.dialogRef.close();
            });
        }
        if(this.deleteFormGroup.value.delete != 'DELETE'){
        }

    }

}
